import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import HomePage from "../pages/home/page";
import ProductsPage from "../pages/products/page";
import ArticleGuide from "../pages/articles/spreadsheet-guide/page";
import ArticlePage from "../pages/articles/ArticlePage";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "/en",
    element: <HomePage />,
  },
  {
    path: "/pt",
    element: <HomePage />,
  },
  {
    path: "/de",
    element: <HomePage />,
  },
  {
    path: "/en/products",
    element: <ProductsPage />,
  },
  {
    path: "/pt/products",
    element: <ProductsPage />,
  },
  {
    path: "/de/products",
    element: <ProductsPage />,
  },
  {
    path: "/products",
    element: <ProductsPage />,
  },
  {
    path: "/en/articles/cssbuy-spreadsheet-guide",
    element: <ArticleGuide />,
  },
  {
    path: "/pt/articles/cssbuy-spreadsheet-guide",
    element: <ArticleGuide />,
  },
  {
    path: "/de/articles/cssbuy-spreadsheet-guide",
    element: <ArticleGuide />,
  },
  {
    path: "/:lang/articles/:slug",
    element: <ArticlePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;